import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import EventCard from '../EventCard';
import SignUpPrompt from '../SignUpPrompt';
import EventSearchRecommendRace from '../EventSearchRecommendRace';

import styles from './EventList.css';

/**
 * Event list presentational component
 * TODO: use correct semantic list elements
 */
const EventList = ({
  events,
  hasUserCookie,
  showPrompt,
  source,
  total,
}) => (
  <div className="event-list">
    {events.slice(0, 6).map(event => (
      <EventCard
        key={event.id}
        {...event}
        source={source}
        className="event-list__item"
      />
    ))}
    {(events.length > 6 && !hasUserCookie && showPrompt) &&
      <div className="event-list__prompt">
        <SignUpPrompt
          title="Discover Events You Love"
          text="See the events that work for you based on your ability, fitness, location and preference. Sign up today."
          buttonText="Get Started"
        />
      </div>}
    {events.slice(6).map(event => (
      <EventCard
        key={event.id}
        {...event}
        source={source}
        className="event-list__item"
      />
    ))}
    {events.length === total &&
    <EventSearchRecommendRace isSearchPage className={'event-list__item'} />
    }
  </div>
);

EventList.propTypes = {
  /**
   * Array of event data objects to render
   */
  events: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
   * Boolean describing user autenticated state.
   */
  hasUserCookie: PropTypes.bool,
  /**
   * Boolean used to show sign up prompt.
   */
  showPrompt: PropTypes.bool,
  /**
   * String source of list location.
   */
  source: PropTypes.string,
  /**
   * Number of events for current list (and query) found on the server
   */
  total: PropTypes.number.isRequired,
};

EventList.defaultProps = {
  hasUserCookie: false,
  showPrompt: false,
  source: undefined,
};

export default EventList;



// WEBPACK FOOTER //
// ./app/src/components/EventList/EventList.react.js